import React from 'react';
import { EditableQuestion } from '../../../../../types';
import { StyledQuestionViewerTitle } from '../styles';

interface Props {
  question: EditableQuestion;
}

const QuestionViewerHeader = ({ question }: Props) => {
  const isFollowUp = Boolean(question.parent_question_id);
  const questionTitle = question.question || 'No title provided';

  if (isFollowUp) {
    return <StyledQuestionViewerTitle>{questionTitle} – FOLLOW UP</StyledQuestionViewerTitle>;
  }

  return <StyledQuestionViewerTitle>{questionTitle}</StyledQuestionViewerTitle>;
};
export default QuestionViewerHeader;
